import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';

import * as classes1 from './BobActionMenu.module.css';
import classes from '../containers/Dashboard/EquipmentPage/SensorPanel.module.css';

const GridAggregateSelector = ({
    ...props
}) => {
  
    const [menuOpen, setMenuOpen] = useState(false);
    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleClickAway = () => {
        setMenuOpen(false);
    };

    const clickOperator = (e,val) => {
        handleClickAway();
        props.setAggregateType(val);
    };

    return (
        <ClickAwayListener
            onClickAway={() => handleClickAway()}
        >
            <div className={classes.SensorFilterContainer} style={{marginTop: '0'}}>
                <React.Fragment>
                    <Button
                        onClick={handleToggle}
                        style={{textTransform: 'none !important'}}
                        className={`action-dropdown conditional_dropdown`}
                    >
                        {props.aggregateType}
                        <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                    </Button> 
                    {menuOpen ?
                        <Paper style={{right: 'unset'}} className={classes1.BobActionMenu}>                         
                            <React.Fragment>
                                <Button style={{fontSize: '1.2rem'}} onClick={(e) => clickOperator(e, 'None')}>
                                    None
                                </Button>
                            </React.Fragment>             
                            <React.Fragment>
                                <Button style={{fontSize: '1.2rem'}} onClick={(e) => clickOperator(e, 'Minimum')}>
                                    Minimum
                                </Button>
                            </React.Fragment>  
                            <React.Fragment>
                                <Button style={{fontSize: '1.2rem'}} onClick={(e) => clickOperator(e, 'Maximum')}>
                                    Maximum
                                </Button>
                            </React.Fragment>             
                            <React.Fragment>
                                <Button style={{fontSize: '1.2rem'}} onClick={(e) => clickOperator(e, 'Average')}>
                                    Average
                                </Button>
                            </React.Fragment>             
                            <React.Fragment>
                                <Button style={{fontSize: '1.2rem'}} onClick={(e) => clickOperator(e, 'Runtime')}>
                                    Runtime
                                </Button>
                            </React.Fragment>             
                        </Paper>
                        :''}
                </React.Fragment>
            </div>
        </ClickAwayListener>
    );
};

export default GridAggregateSelector;
